import { useQuery } from "@tanstack/react-query";
import { useCart } from "./cart";
import { branchOrderBlock } from "./branch-ordering";
import { branchesQuery } from "./queries";
import { storefrontOrderingPaused, useStorefront } from "./storefront";

export function useBranchOrdering() {
  const { cart } = useCart();
  const storefront = useStorefront();
  const { data: branches } = useQuery(branchesQuery());
  const branch = branches?.find((entry) => entry.id === cart.orderType?.branchId);
  const block = storefrontOrderingPaused(storefront)
    ? "global" as const
    : branchOrderBlock(branch, cart.orderType?.fulfillment);
  return { branch, block };
}
